var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ini-list"},[_c('div',{staticClass:"listview listview--bordered"},_vm._l((_vm.entries),function(entry){return _c('ini-list-item',_vm._b({nativeOn:{"click":function($event){return _vm.itemClicked(entry)}}},'ini-list-item',entry,false))}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }